// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PERSON_PAGE_LOADING() {
      return {
        isLoading: true,
        personPage: action.personPage
      };
    },
    PERSON_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.personPage
      };
    },
    PERSON_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
